import type { FaireProductEntity } from "../../entity_types/product";

export const p_958mj3kbr6: FaireProductEntity = {
  token: "p_958mj3kbr6",
  type: "product",
  name: "Thyroid + Adrenal Support | 10 ml",
  brandToken: "b_5dagse75md",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a2c2c613abd7c5517d080f4bbbe0f0c0b66b9624277bf36b08c0de7c9a15bc73.png",
  galleryImageUrls: [],
  priceDollars: 17,
  description:
    "The thyroid and adrenal glands work together to produce essential hormones needed throughout the body. Factors, including high stress, can affect their function. This carefully formulated blend of 100% therapeutic grade essential oils is designed to support your overall wellbeing and support thyroid and adrenal function.\nFor more product information or questions on products, please join our VIP group on Facebook. ",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:00.872Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
